import type { Stream } from './agent';

export function parseStreamList(data: unknown): Stream[] {
    const items = Array.isArray(data) ? data : (data as { results?: unknown } | null)?.results;
    if (
        !Array.isArray(items) ||
        items.some(
            (item) =>
                !item ||
                !Number.isSafeInteger(item.id) ||
                item.id <= 0 ||
                typeof item.is_active !== 'boolean' ||
                !Number.isFinite(item.balance) ||
                item.balance < 0 ||
                !item.category ||
                typeof item.category.name !== 'string'
        ) ||
        new Set(items.map((item) => item.id)).size !== items.length
    ) {
        throw new Error('Не удалось прочитать состояние потоков. Повторите проверку.');
    }
    return items;
}
